import { type FC, useState } from "react";

import { Colors, Tooltip } from "@snapchat/snap-design-system";
import { ChevronDownIcon, InformationIcon } from "@snapchat/snap-design-system-icons";

import { Flexbox } from "../../shared/components";

import { AccordionContent, AccordionHeader, AccordionTitle, IconButtonStyled } from "./TrendingTagAccordion.style";
import { TrendingTagsList } from "./TrendingTagsList";
import { TrendingTagsTitle, TrendingTagsTooltip } from "./messages.generated";

interface TrendingTagAccordionProps {
    onRowClick: (tag: string) => void;
    defaultExpanded?: boolean;
}

const DOCS_LINK =
    "https://docs.snap.com/lens-studio/publishing/submitting/submitting-your-lens#snap-ar-tags-of-the-month";

export const TrendingTagAccordion: FC<TrendingTagAccordionProps> = ({ onRowClick, defaultExpanded = true }) => {
    const [isExpanded, setIsExpanded] = useState(defaultExpanded);

    return (
        <>
            <AccordionHeader
                onClick={() => {
                    setIsExpanded((pevExpanded) => !pevExpanded);
                }}
            >
                <IconButtonStyled
                    type="default"
                    shape={"circle"}
                    icon={<ChevronDownIcon size={24} />}
                    isExpanded={isExpanded}
                />
                <Flexbox>
                    <AccordionTitle>
                        <TrendingTagsTitle />
                    </AccordionTitle>
                    <Tooltip
                        content={
                            <TrendingTagsTooltip
                                feature={
                                    <i>
                                        <TrendingTagsTitle />
                                    </i>
                                }
                                link={
                                    <a href={DOCS_LINK} target="_blank" rel="noreferrer">
                                        here
                                    </a>
                                }
                            />
                        }
                    >
                        <InformationIcon size={16} fill={Colors.Gray.V300} />
                    </Tooltip>
                </Flexbox>
            </AccordionHeader>
            {isExpanded && (
                <AccordionContent isExpanded>
                    <TrendingTagsList onRowClick={onRowClick} />
                </AccordionContent>
            )}
        </>
    );
};
